import React from 'react';
import { Hero } from './components/Hero';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { TargetAudience } from './components/TargetAudience';
import { SystemOverview } from './components/SystemOverview';
import { Modules } from './components/Modules';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Offer } from './components/Offer';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-cream-200 font-sans selection:bg-brand-200 selection:text-brand-900" data-id="element-0">
      <Hero data-id="element-1" />
      <Testimonials data-id="element-2" />
      <PainPoints data-id="element-3" />
      <TargetAudience data-id="element-4" />
      <SystemOverview data-id="element-5" />
      <Modules data-id="element-6" />
      <Bonuses data-id="element-7" />
      <Comparison data-id="element-8" />
      <Offer data-id="element-9" />
      <FAQ data-id="element-10" />
      <FinalCTA data-id="element-11" />
      <PurchasePopup data-id="element-12" />
      <MetaPixel data-id="element-13" />
    </div>;
}